import { DataType } from "src/app/core/enums/datatype.enum";
import { DefaultMetadata } from "src/app/core/list/metadata/default.metadata";
import { Metadata } from "src/app/core/list/metadata/metadata.component";

export class PoliticaDePrivacidadeMetadata {

  static getMetadata(): Metadata[] {
    return DefaultMetadata.getMetadata(true)
                          .concat(
      [
        {
          fieldId: 'nome',
          fieldName: 'Nome'
        },
        {
          fieldId: 'versao',
          fieldName: 'Versão',
          dataType: DataType.NUMBER
        }
      ])
  }

}